"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var BasicIcon_1 = __importDefault(require("../../../../../../components/common/BasicIcon"));
var FormComponent_1 = __importDefault(require("../../../../../../components/FormComponents/FormComponent"));
var postSlice_1 = require("../../../../../../features/post/postSlice");
var globalSlice_1 = require("../../../../../../features/global/globalSlice");
var schemaSlice_1 = require("../../../../../../features/post/schemaSlice");
var schemaHelper_1 = require("../../../../../../helpers/schemaHelper");
var PostTabsContext_1 = require("../../../../../../contexts/PostTabsContext");
var translationHelper_1 = require("../../../../../../helpers/translationHelper");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var ApartmentCard = function (_a) {
    var step = _a.step, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded;
    var rows = step.fields.rows, order = step.order, name = step.name, config = step.config;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var id = post.id;
    var tabRef = react_1.useRef(null);
    var handleTabPositionChange = react_1.useContext(PostTabsContext_1.PostTabsContext).handleTabPositionChange;
    var currentPropertyData = react_redux_1.useSelector(schemaSlice_1.selectCurrentPropertyType);
    react_1.useEffect(function () {
        var refCurrent = tabRef.current;
        if (refCurrent && rows) {
            handleTabPositionChange(name, refCurrent.offsetTop, refCurrent.offsetTop + refCurrent.offsetHeight);
        }
    }, [isLoaded]);
    var uploadMedia = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.uploadApartmentMedia(id, post.sections.apartment_info[0].entity_id, files))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_1.response.data.errors[key]
                            ? t('ERRORS.' + e_1.response.data.errors[key][0])
                            : t('ERRORS.IMAGE_UPLOAD_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeEntityMedia = function (mediaId) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.removeEntityMediaByID(id, post.sections.apartment_info[0].entity_id, mediaId))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_2 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REMOVE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reorderMedia = function (from, to) { return __awaiter(void 0, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.reorderApartmentMedia(id, post.sections.apartment_info[0].entity_id, from, to))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.IMAGE_REORDER_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    if (!rows) {
        return null;
    }
    var validatedRows = schemaHelper_1.excludeFieldsByCondition(rows, formikProps.values);
    return (react_1.default.createElement("div", { ref: tabRef },
        react_1.default.createElement("div", { className: classnames_1.default('element form-section', styles_module_scss_1.default.card), key: order },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_header },
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.header_title },
                        react_1.default.createElement(BasicIcon_1.default, { iconClass: step.icon }),
                        react_1.default.createElement("h3", null, t(config.displayCondition.headerTitles[currentPropertyData])))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_content },
                    react_1.default.createElement("div", { className: "ui grid stackable form" }, validatedRows.map(function (row, i) {
                        var _a;
                        return (react_1.default.createElement("div", { className: classnames_1.default('equal width row', (_a = {},
                                _a[styles_module_scss_1.default.description] = translationHelper_1.isDescriptionFieldSection(row),
                                _a)), key: i }, Object.keys(row).map(function (fieldName) {
                            var field = row[fieldName];
                            return (react_1.default.createElement(FormComponent_1.default, { key: fieldName, field: field, fieldName: fieldName, order: order, section: name, index: 0, formikProps: formikProps, disabled: field.disabled, onMediaUpload: function (files) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, uploadMedia(files)];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); }, removeEntityMedia: function (mediaId) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, removeEntityMedia(mediaId)];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); }, onMediaReorder: function (from, to) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        reorderMedia(from, to);
                                        return [2 /*return*/];
                                    });
                                }); } }));
                        })));
                    })))))));
};
exports.default = ApartmentCard;
